import React, { useEffect, useMemo } from 'react';
import { useTranslate } from '@im/react-localization';
import { Customer } from '../../hooks/customer-search';
import {
  PRICE_CONSTS,
  useCustomersSearchQuery,
  useSegmentLookupQuery,
} from '../../hooks/singlePricingSearch';
import CustomSearchBar from './CustomSearchBar';

type CustomerSearchBarType = {
  onValueSelected: (value?: any) => void;
  searchQuery: any;
  setFilter: (value?: any) => void;
  value: any;
};

export default function CustomerSearchBar({
  onValueSelected,
  searchQuery,
  setFilter,
  value,
}: Readonly<CustomerSearchBarType>) {
  const translate = useTranslate();
  const { data: { list } = {}, isLoading: customersLoading } =
    useCustomersSearchQuery({
      ...searchQuery,
    });
  const { data: segmentData, isLoading: isLoadingSegmentLookup } =
    useSegmentLookupQuery(value);

  useEffect(() => {
    if (value?.id) {
      onValueSelected({
        ...value,
        ...{ segmentId: segmentData?.[0]?.segmentId },
      });
      setFilter({
        field: searchQuery?.filter?.field || PRICE_CONSTS.CUSTOMER,
        value: '',
      });
    }
  }, [segmentData?.[0]?.segmentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const formatValue = (value: any) => {
    return `${value.customerName} ${value.customerBranchNumber}-${value.customerNumber}`;
  };
  const renderValue = (value: any) => {
    return `${
      segmentData?.[0]?.segmentId
        ? `(${translate('Pricing.SinglePriceSearchFilterSegment')})`
        : ''
    } ${value.customerName} ${value.customerBranchNumber}-${
      value.customerNumber
    }`;
  };
  const onValueSelectedHandler = (customer: Customer | null) => {
    onValueSelected(customer);
    if (!customer?.id) {
      setFilter({
        field: searchQuery?.filter?.field || PRICE_CONSTS.CUSTOMER,
        value: '',
      });
    }
  };
  useEffect(() => {
    if (value?.id) {
      setFilter({
        field: searchQuery?.filter?.field || PRICE_CONSTS.CUSTOMER,
        value: '',
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  const dropdownOptions = useMemo(
    () => [
      {
        label: translate('Pricing.SinglePriceSearchFilterCustomer'),
        value: PRICE_CONSTS.CUSTOMER,
      },
    ],
    [translate]
  );

  return (
    <CustomSearchBar
      disabled={!!value}
      dropdownOptions={dropdownOptions}
      formatValue={formatValue}
      isLoading={customersLoading}
      isLoadingSelected={isLoadingSegmentLookup}
      onDropdownOptionChange={({ value: field }) => {
        setFilter({
          field,
          value: '',
        });
      }}
      onRemoveSelected={() => onValueSelectedHandler(null)}
      onSearch={(data: any) => {
        setFilter({
          field: searchQuery?.filter?.field || PRICE_CONSTS.CUSTOMER,
          value: data.inputValue,
        });
      }}
      onValueSelected={onValueSelectedHandler}
      options={list || []}
      placeholder={translate('Pricing.SinglePriceSearchPlaceholderCustomer')}
      renderValue={renderValue}
      selectedValue={value}
      value={searchQuery?.filter?.value}
    />
  );
}
